import TopObject from '@vg/top-object';
import React from 'react';
import LazyLoad from 'react-lazy-load';
import { themer } from '@spp/theme-provider';

@themer('@vg/top-object')
export default class LazyLoadedTopObject extends TopObject {
    isPentFactBox = () => {
        const { description = '' } = this.props.data;
        return description.indexOf('Pent.no') === 0;
    };

    render() {
        const { subtype, theme } = this.props;

        if (subtype === 'top') {
            return <div className={theme['top-object-in-header']}>{super.render()}</div>;
        }

        if (this.isPentFactBox()) {
            return null;
        }

        return (
            <LazyLoad offset={1000} debounce={false} throttle={100}>
                {super.render()}
            </LazyLoad>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/local-components/article/LazyLoadedTopObject.js
 **/